import React from 'react';
import { NamedLink } from '../../components';
import { useConfiguration } from '../../context/configurationContext';
import css from './SecondaryBar.module.css';

const rightSideButtons = [
  {
    label: 'How it Works',
    name: 'how-it-works',
  },
  {
    label: 'About',
    name: 'about-us',
  },
  {
    label: 'Help',
    name: 'help',
  },
];

function SecondaryBar() {
  const config = useConfiguration();
  const categories = config?.categoryConfiguration?.categories ?? [];

  if (categories.length === 0) {
    return null;
  }

  return (
    <div className={css.secondaryTopbar}>
      <div className={css.desktopLeft}>
        {[{ id: 'shop_all', name: 'Shop all' }, ...categories].map((category, index) => {
          return (
            <NamedLink
              name="SearchPage"
              to={{
                search: category.id === 'shop_all' ? `` : `?pub_categoryLevel1=${category.id}`,
              }}
              className={category.id === 'shop_all' ? css.categoryLink : css.categoryLinks}
              key={index}
            >
              {category.name}
            </NamedLink>
          );
        })}
      </div>
      <div className={css.desktopRight}>
        {rightSideButtons.map((button, index) => {
          return (
            <div key={index}>
              <NamedLink
                name="CMSPage"
                params={{ pageId: button.name }}
                className={css.categoryLinks}
              >
                {button.label}
              </NamedLink>
            </div>
          );
        })}
      </div>
      <div className={css.mobileLeft}>
        {[{ id: 'shop_all', name: 'Shop all' }].map((category, index) => {
          return (
            <div className={css.shopAll} key={index}>
              <NamedLink name="SearchPage" className={css.categoryLinks}>
                {category.name}
              </NamedLink>
            </div>
          );
        })}
      </div>
      <div className={css.mobileRight}>
        {rightSideButtons.map((button, index) => {
          return (
            <NamedLink
              key={index}
              className={css.categoryLinks}
              name="CMSPage"
              params={{ pageId: button.name }}
              style={{ color: '#fff' }}
            >
              {button.label}
            </NamedLink>
          );
        })}
      </div>
    </div>
  );
}
export default SecondaryBar;
